import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import React, { useMemo } from "react";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ImportantInfo = ({ hotelData }) => {
  const t = useTranslationDetector('hotel');
  const hotelRule = hotelData?.HotelRule || {};
  const registryNumber = hotelData?.RegistryNumber || '';
  const certificateNote = t('tourismCartNumber');

  // API'den gelen verilerle info listesi oluştur
  const infoList = useMemo(() => {
    const list = [];

    // Çocuk bilgisi
    if (hotelRule.MaxFreeAge !== undefined || hotelRule.MaxBabyAge !== undefined || hotelRule.FreeChildCount !== undefined) {
      let childInfo = t('childrenInfoNotAvailable');
      if (hotelRule.FreeChildCount > 0) {
        childInfo = t('childrenFreeUntil', { age: hotelRule.FreeChildCount });
      } else if (hotelRule.MaxFreeAge > 0) {
        childInfo = t('childrenFreeUntil', { age: hotelRule.MaxFreeAge });
      }

      list.push({
        id: "info-1",
        icon: byPrefixAndName.far['baby-carriage'],
        title: t('childrenLabel'),
        content: childInfo,
      });
    }

    // Evcil hayvan bilgisi
    const petAllowed = hotelRule.IsPetAllowed;
    list.push({
      id: "info-2",
      icon: byPrefixAndName.far['dog'],
      title: t('pets'),
      content: petAllowed ? t('petsAllowed') : t('petsNotAllowed'),
    });

    // Sigara bilgisi
    const smokingAllowed = hotelRule.IsSmokingAllowed;
    list.push({
      id: "info-3",
      icon: byPrefixAndName.far['smoking'],
      title: t('smoking'),
      content: smokingAllowed ? t('smokingAllowed') : t('smokingNotAllowed'),
    });

    // Minimum yaş bilgisi
    if (hotelRule.CheckinMinAge) {
      list.push({
        id: "info-4",
        icon: byPrefixAndName.far['user'],
        title: t('minAge'),
        content: t('minAgeForCheckin', { age: hotelRule.CheckinMinAge }),
      });
    }

    return list.length > 0 ? list : [{
      id: "info-default",
      icon: byPrefixAndName.far['circle-info'],
      title: t('info'),
      content: t('noImportantInfo'),
    }];
  }, [hotelRule, t]);

  return (
    <div className="flex flex-col gap-4 md:gap-6 md:py-12 py-6">
      <div>
        <div className="text-xl sm:text-[23px] md:text-[29px]! font-semibold">
          {t('importantInfo')}
        </div>
        <div className="text-foreground-muted leading-21 text-base mt-1">
          {t('importantInfoDescription')}
        </div>
      </div>

      <div className="flex flex-col gap-4 md:gap-6">
        {infoList.map((info) => (
          <div className="w-full flex flex-col gap-4 p-6 rounded-[10px] bg-white border border-solid border-[#D0D0DC]" key={info.id}>
            <div className="flex items-center flex-row gap-2">
              <FontAwesomeIcon
                icon={info.icon}
                className="w-[22px]! h-[22px]!"
              />

              <span className="font-semibold text-base leading-21">
                {info.title}
              </span>
            </div>
            <div className="sm:font-medium text-base leading-21">
              {info.content}
            </div>
          </div>
        ))}
      </div>

      {registryNumber && (
        <div className="flex justify-end font-semibold mt-6">
          {certificateNote} {registryNumber}
        </div>
      )}
    </div>
  )
};

export default ImportantInfo;